import { handleCommonErrors } from 'utils/api'
import {
  InvalidUserUnauthorized,
  InvalidUserWrongAccountUsed,
} from '../useAPIKinerja'

import type { TPraktikKinerjaFormName } from 'types/kinerja-ps-pegawai'

export const basePath = '/guru/pps'

export const apiPaths = {
  basePath,
  summary: (periodeId: string) => `${basePath}/v1/pps/${periodeId}/summary`,
  rhkExists: (periodeId: string) =>
    `${basePath}/v1/pps/${periodeId}/rhk-atasan/exists`,
  perencanaan: `${basePath}/v1/pps/perencanaan`,
  perencanaanByPeriod: (periodeId: string) =>
    `${apiPaths.perencanaan}/${periodeId}`,
  summaryPerencanaan: (periodeId: string) =>
    `${apiPaths.perencanaanByPeriod(periodeId)}/summary`,
  getPeriod: `${basePath}/v1/pps/periode`,
  praktikKinerja: `${basePath}/v1/pps/perencanaan/praktik-kinerja`,
  pengembanganKompetensi: `${basePath}/v1/pps/perencanaan/pengembangan-kompetensi`,
  ajukanPerencanaan: (periodeId: string) =>
    `${apiPaths.perencanaan}/${periodeId}/ajukan`,
  profile: `${basePath}/v1/pps/profile`,
  mulaiPelaksanaan: `${basePath}/v1/pps/perencanaan/mulai-pelaksanaan`,
  syncToEkin: `${basePath}/v1/pps/perencanaan/sync-to-ekin`,
  pelaksanaan: `${basePath}/v1/pps/pelaksanaan`,
  resetSkp: (periodeId: string) => `${basePath}/v1/pps/${periodeId}/skp/reset`,

  praktikKinerjaPerencanaanSummary: (skpPsId: string) =>
    `${apiPaths.pelaksanaan}/praktik-kinerja/${skpPsId}/summary/perencanaan`,
  praktikKinerjaForm: (skpPsId: string, formName: TPraktikKinerjaFormName) =>
    `${apiPaths.pelaksanaan}/praktik-kinerja/skp-ps/${skpPsId}/form-values/${formName}`,

  dokumenAkuntabilitas: (skpPsId: string) =>
    `${basePath}/v1/pps/pelaksanaan/dokumen-akuntabilitas/skp-ps/${skpPsId}/dokumen-tersedia`,
} as const

export const queryKeys = {
  API_GET_PRAKTIK_KINERJA_OPTIONS: 'perencanaan-ps-praktik-kinerja',
  API_GET_SATUAN_PENDIDIKAN_OPTIONS: 'perencanaan-ps-satuan-pendidikan',
  API_GET_PENGEMBANGAN_KOMPETENSI_INDIKATOR: 'perencanaan-ps-indikator',
  API_GET_PENGEMBANGAN_KOMPETENSI_KATEGORI: 'perencanaan-ps-kategori',
  API_GET_PENGEMBANGAN_KOMPETENSI_KEGIATAN: 'perencanaan-ps-kegiatan',
  API_GET_PERIODE: 'kinerja-ps-pegawai-periode',
  API_GET_PERENCANAAN_SUMMARY: 'perencanaan-ps-summary',
  API_GET_PERENCANAAN: 'perencanaan-ps',
  API_GET_SUMMARY: 'ps-pegawai-summary',
  API_GET_RHK_EXISTS: 'ps-pegawai-rhk-exists',
  API_GET_PROFILE: 'ps-pegawai-profile',
  API_GET_PELAKSANAAN_PERILAKU_KERJA: 'pelaksanaan-ps-perilaku-kerja',
  API_GET_PELAKSANAAN_PENGEMBANGAN_KOMPETENSI:
    'pelaksanaan-ps-pengembangan-kompetensi',
  API_GET_PRAKTIK_KINERJA_PERENCANAAN_SUMMARY:
    'pelaksanaan-ps-praktik-kinerja-perencanaan-summary',
  API_GET_PELAKSANAAN_FORM_PRAKTIK_KINERJA:
    'pelaksanaan-ps-form-praktik-kinerja',
  API_GET_PRAKTIK_KINERJA_PELAKSANAAN_SUMMARY:
    'pelaksanaan-ps-praktik-kinerja-summary',
  API_GET_PRAKTIK_KINERJA_FORM_VALUES:
    'pelaksanaan-ps-praktik-kinerja-form-values',
  API_GET_DOKUMEN_AKUNTABILITAS: 'ps-pegawai-dokumen-akuntabilitas',
}

export function handleError(status, path, error) {
  if (status === 401) {
    throw new InvalidUserUnauthorized(path, error)
  } else if (status === 403) {
    throw new InvalidUserWrongAccountUsed(path, error)
  } else {
    handleCommonErrors(status, path, error)
  }
}

export function validateStatus(status: number) {
  return status < 400
}
